import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-600 text-xs font-medium mb-4">
            题材分类
          </span>
          <h2
            className="text-2xl md:text-4xl font-bold text-foreground-950"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            探索漫画题材
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            八大题材分类，总有一款适合你。点击进入，发现属于你的漫画世界
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 md:p-6 text-center transition-all duration-300 hover:bg-primary-500 hover:text-white cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto rounded-full bg-primary-100 text-primary-500 flex items-center justify-center mb-4 group-hover:bg-white/20 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3
                className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-white mb-2"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 group-hover:text-white/80 line-clamp-2 mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400 group-hover:text-white/60">
                {cat.count.toLocaleString()} 部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}